import * as _ from 'lodash-es';
import {TV_CHART_CANDLE_SIZE_BY_PERIOD} from '../../../components/trading-view-chart';
import {ResolutionString} from '../../../components/trading-view-chart/charting-library/datafeed-api';
import {CandlePeriod} from '../../../enums/candle-period';

export interface ChartResolutionDef {
    chartValue: ResolutionString;
    candlePeriod: CandlePeriod;
}

export const CHART_RESOLUTIONS_DEF: ChartResolutionDef[] = [
    CandlePeriod.ONE_MINUTE,
    CandlePeriod.FIVE_MINUTES,
    CandlePeriod.TEN_MINUTES,
    CandlePeriod.FIFTEEN_MINUTES,
    CandlePeriod.THIRTY_MINUTES,
    CandlePeriod.HOUR,
    CandlePeriod.DAY,
    CandlePeriod.WEEK,
    CandlePeriod.MONTH
].map(candlePeriod => ({
    chartValue: TV_CHART_CANDLE_SIZE_BY_PERIOD[candlePeriod],
    candlePeriod
}));

export const CHART_RESOLUTIONS = CHART_RESOLUTIONS_DEF.map(def => def.chartValue);

export const CHART_RESOLUTIONS_DICT: {[chartResolutionValue in ResolutionString]: ChartResolutionDef} = _.keyBy(
    CHART_RESOLUTIONS_DEF,
    (def: ChartResolutionDef) => def.chartValue
);
